var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center col-md-8 offset-md-2 pb-4"},[_c('h2',{staticClass:"mb-10"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"para",domProps:{"innerHTML":_vm._s(_vm.description)}})])}
var staticRenderFns = []

export { render, staticRenderFns }